import parse from 'html-react-parser'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next/pages'
import { AlreadyCustomerModalProps } from './types'
import { MarketingDataKeys } from 'store/marketing/types'
import { useStoreSelector } from 'hooks/store'
import { Heading, Modal } from '@boltenergy-be/design-system'
import { PORTAL_URL } from 'constants/constants'
import Link from 'components/link/Link'

const AlreadyCustomerModal = ({ isOpen, onRequestClose, email }: AlreadyCustomerModalProps) => {
  // Redux
  const marketing = useStoreSelector((store) => store.marketing)
  const isPartnerFlow = !!marketing[MarketingDataKeys.PARTNER_ID]

  // i18n
  const { t } = useTranslation('registration')

  // Next router
  const router = useRouter()
  const { locale } = router

  return (
    <Modal title={t(!isPartnerFlow ? 'alreadyCustomer.title' : 'alreadyCustomer.sales.title')} {...{ isOpen, onRequestClose }}>
      <p>{t(!isPartnerFlow ? 'alreadyCustomer.description' : 'alreadyCustomer.sales.description')}</p>

      <Link
        representation="button"
        external
        trailingIcon="arrowRight"
        target="_blank"
        href={
          !isPartnerFlow ? `${PORTAL_URL}/login?lang=${locale}` : `${PORTAL_URL}/sales/contracts?lang=${locale}&customer_email=${email}`
        }
      >
        {t(!isPartnerFlow ? 'alreadyCustomer.link' : 'alreadyCustomer.sales.link')}
      </Link>

      <Heading as="h2" variant="h6">
        {t('alreadyCustomer.notCorrect')}
      </Heading>
      <p>{parse(t('alreadyCustomer.contact'))}</p>
    </Modal>
  )
}

export default AlreadyCustomerModal
